import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	ariaLabel: {
		id: 'ui.exit.ariaLabel',
		defaultMessage: 'Close',
		description: 'Aria label for exit button',
	},
});
